import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @param {object} payload
 * @param {string} payload.product_ids - The product ids that were viewed
 */
export const onTrackProductImpression = async (payload) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.ProductImpression,
    data: {
      product_ids: payload.product_ids,
      scope: 'one_page_store',
      page_type: 'one_page_store',
    },
  });
};
